import { useGetSitesV3Query } from '@/entities/sites/api/sitesApi';
import optionsToIds from '@/entities/sites/ui/site-select/lib/optionsToIds';
import SiteSelect from '@/entities/sites/ui/site-select/ui';
import { FilterState } from '@/shared/lib/filter/model/types';

export interface ISiteSelect {
  value?: FilterState['sites'];
  onChange: (value: FilterState['sites']) => void;
  className?: string;
  disabled?: boolean;
}

export default function Select({
  value = [],
  onChange,
  className = '',
  disabled,
}: ISiteSelect) {
  const getSitesQuery = useGetSitesV3Query();
  const sites = getSitesQuery.data?.map((site) => ({
    id: site.id,
    url: site.domain,
  }));

  return (
    <div className={`min-w-[180px] ${className}`}>
      <SiteSelect
        data={sites}
        current={value.filter((id) => +id).map((id) => +id)}
        onChange={(option) => {
          onChange(optionsToIds(option));
        }}
        disabled={disabled}
      />
    </div>
  );
}
